import { render, staticRenderFns } from "./taskItemEditDialog.vue?vue&type=template&id=70da9cec&"
import script from "./taskItemEditDialog.vue?vue&type=script&lang=js&"
export * from "./taskItemEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports